import Vue from "vue";
import Router from "vue-router";
import { routes } from "./routes";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = routes;

const createRouter = () =>
  new Router({
    mode: "hash",
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

router.beforeEach((to, from, next) => {
  //keep-alive继承上一页路由滑动高度问题
  setTimeout(() => {
    if (document.body.getElementsByClassName("routerView_box")) {
      document.body
        .getElementsByClassName("routerView_box")[0]
        .scrollIntoView(false);
    }
  });
  next();
});

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    document.body
      .getElementsByClassName("routerView_box")[0]
      .scrollIntoView(false);
  });
  next();
});

export default router;
